import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  useDisclosure,
  ModalCloseButton,
  Text,
  Flex,
  Box,
  useToast,
  Stack,
  Progress,
} from "@chakra-ui/react";
import { InfoTrocas } from "./InfosTroca";
import { InputsTroca } from "./InputsTroca";
import { useState } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { baseURL } from "../../../../services/api";

const schema = yup.object().shape({
  quantidade: yup.string().required("Campo obrigatório"),
  descricao: yup.string().required("Campo obrigatório"),
 
});

export function ModalTrocas({ onClose, dados, numeroNota, codProduto, filtrarStatus, usuario, sequencia }) {


  const { isOpen, onOpen } = useDisclosure();
  const [foto1, setFoto1] = useState(null);
  const [foto2, setFoto2] = useState(null);
  const [foto3, setFoto3] = useState(null);
  const [descricao, setDescricao] = useState("");
  const [quantidade, setQuantidade] = useState("");
  const [progress, setProgress] = useState(0);
  const [changeColor, setChangeColor] = useState(false);

  const toast = useToast();

  const {
    register,
    formState: { errors, isSubmitting },
    handleSubmit,
  } = useForm({
    resolver: yupResolver(schema),
  });

  function replaceBase64Image(image) {
    return image?.replace(/^data:image\/[a-z]+;base64,/, "");
  }

  const file = [
    replaceBase64Image(foto1),
    replaceBase64Image(foto2),
    replaceBase64Image(foto3),
  ];

  const containsPhoto = [foto1, foto2, foto3].includes(null);
  const filterPhoto = [foto1, foto2, foto3].filter((item) => item === null);

  async function SendForm(e) {

    if (containsPhoto) {
      return toast({
        position: "top",
        title: "Erro ao enviar",
        description: `${filterPhoto.length > 1 ? "Faltam" : "Falta"
          } preencher ${filterPhoto.length} ${filterPhoto.length > 1 ? "campos" : "campo"
          } de imagem
`,
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }

    try {
      const params = {
        file,
        descricao: e.descricao,
        quantidade: e.quantidade,
        numero_nota: numeroNota,
        codigo_produto: codProduto,
        numero_unico: dados[0].numero_pedido,
        cod_usu: usuario,
        sequencia: sequencia,
      };

      const response = await baseURL.post(
        `/pedido/upload-drive-devolucao`,
        params,
        {
          onUploadProgress: (progressEvent) => {
            setProgress(
              Math.round((progressEvent.loaded * 100) / progressEvent.total) +
              "%"
            );
            progressEvent.loaded === progressEvent.total &&
              setChangeColor(true);
          },
        }
      );

      toast({
        position: "top",
        title: "Sucesso",
        description: "Informações enviadas com sucesso",
        status: "success",
        duration: 9000,
        isClosable: true,
      });
      filtrarStatus();
    } catch (error) {
      console.log(error);
      toast({
        position: "top",
        title: "Erro ao enviar",
        description:
          "Ocorreu um erro ao enviar as informações, contate o suporte",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }

    onClose();
  }

  return (
    <>
      <Modal zIndex={9999} isOpen={!isOpen} onClose={onClose} size="6xl">
        <ModalOverlay />
        <ModalContent as="form" onSubmit={handleSubmit(SendForm)}>
          <ModalHeader>
            <Flex
              alignItems={"center"}
              justifyContent={"center"}
              flexDirection={"column"}
            >
              <Text
                textAlign={["center"]}
                fontStyle="normal"
                color={["#378BBF"]}
              >
                SOLICITAÇÃO DE TROCA
              </Text>
              <Flex alignItems={"center"} gap={2} mt={5}>
                <InfoTrocas label="Pedido" value={dados[0].numero_pedido} />
                <InfoTrocas label="Referência" value={dados[0].referencia} />
                <InfoTrocas
                  label="Descrição"
                  value={dados[0].descricao_produto}
                />
                <InfoTrocas label="Cor" value={dados[0].cor} />
                <InfoTrocas
                  label="Quantidade Total"
                  value={dados[0].quantidade_total}
                />
              </Flex>
            </Flex>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <InputsTroca
              setFoto1={setFoto1}
              foto1={foto1}
              setFoto2={setFoto2}
              foto2={foto2}
              setFoto3={setFoto3}
              foto3={foto3}
              setDescricao={setDescricao}
              descricao={descricao}
              setQuantidade={setQuantidade}
              quantidade={quantidade}
              register={register}
              error={errors}
            />
          </ModalBody>

          <ModalFooter pt="5rem" m="auto" position="relative">
            <Flex align="center" flexDir="column" mb="1rem" gap={2}>
              <Text>Finalizar e reportar problemas encontrados nos itens</Text>

              <Button
                colorScheme="blue"
                type="submit"
                mr={3}
                m="auto"
                paddingInline="4rem"
                fontSize=".9rem"
                zIndex={1}
                bg="#378BBF"
                isLoading={isSubmitting}
              >
                FINALIZAR
              </Button>
            </Flex>
          </ModalFooter>
          {progress === 0 ? null : (
            <Button
              colorScheme={changeColor ? "green" : "blue"}
              width={progress === 0 ? "0%" : progress}
              mr={3}
              m="auto"
              position="absolute"
              zIndex={9999}
              bottom="0"
              left="0"
              height=".8rem"
              borderRadius="0"
              fontSize=".6rem"
              paddingBlock={".2rem"}
            ></Button>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}
